import { useCan } from '../../../access/AccessControls';
import { requirementForPath } from '../../../../router/routeAccess';
import React from 'react';
import { Link } from 'react-router-dom';
import { StyledButton } from './styled';

interface IButtonLink {
  to: string;
  children: string;
  color?: string;
  colorScheme?: string;
  disabled?: boolean;
}

const ButtonLink: React.FC<IButtonLink> = ({
  to,
  children,
  color,
  colorScheme,
  disabled,
}) => {
  const allowed = useCan(requirementForPath(to));
  if (!allowed) return null;
  return (
    <Link to={to}>
      <StyledButton color={color} colorScheme={colorScheme} disabled={disabled}>
        {children}
      </StyledButton>
    </Link>
  );
};

export default ButtonLink;
